import { ArrowRight } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { batchArray, countryArray, industryExpertiseArray, postgraduateDegreeArray, professionalBackgroundArray, professionalIndustryArray, undergraduateDegreeArray } from '../../utils/arrays';
import axios from 'axios';

function RegisterModal({ setOpenModal }) {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedState, setSelectedState] = useState("");

    const API_KEY = "R201dzZPMGJDZmdMcUJaRGdEVTUyWHc2OXUzVEJVY1NoMlZCaEJyUg==";

    useEffect(() => {
        axios
            .get("https://api.countrystatecity.in/v1/countries", {
                headers: { "X-CSCAPI-KEY": API_KEY },
            })
            .then((res) => setCountries(res.data))
            .catch((err) => console.error("Error fetching countries:", err));
    }, []);

    useEffect(() => {
        if (selectedCountry) {
            axios
                .get(
                    `https://api.countrystatecity.in/v1/countries/${selectedCountry}/states`,
                    {
                        headers: { "X-CSCAPI-KEY": API_KEY },
                    }
                )
                .then((res) => {
                    setStates(res.data);
                    setCities([]);
                    setSelectedState("");
                })
                .catch((err) => console.error("Error fetching states:", err));
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedCountry && selectedState) {
            axios
                .get(
                    `https://api.countrystatecity.in/v1/countries/${selectedCountry}/states/${selectedState}/cities`,
                    {
                        headers: { "X-CSCAPI-KEY": API_KEY },
                    }
                )
                .then((res) => setCities(res.data))
                .catch((err) => console.error("Error fetching cities:", err));
        }
    }, [selectedCountry, selectedState]);

    return (
        <div>
            <div
                className="fixed inset-0 bg-black/50 flex justify-center items-center z-[110]"
                onClick={() => setOpenModal(false)}
            >
                <div
                    className="bg-white rounded-[30px] scrollbar-thin max-w-[625px] w-full lg:max-h-[90vh] max-h-[80vh] overflow-y-auto lg:py-[46px] py-[30px] lg:px-[40px] px-[20px] relative"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="flex justify-between items-center pb-[42px]">
                        <h2 className="lg:text-[42px] text-[20px] font-[700] font-manrope lg:leading-[66px] leading-[28px] text-[#1F2544]">
                            Register Now
                        </h2>
                        <button
                            onClick={() => setOpenModal(false)}
                        >
                            <img src="/assets/nav/cancel.svg" alt="" />
                        </button>
                    </div>
                    <form className="flex flex-col gap-[20px]">
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Name</h6>
                            <input type="text" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full' placeholder='Enter Name' />
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Batch</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Enter Batch</option>
                                {batchArray?.map((batch, index) => (
                                    <option key={index} value={batch}>
                                        {batch}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Year</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Enter Year</option>
                            </select>
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Email</h6>
                            <input type="text" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full' placeholder='Enter Email' />
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Phone</h6>
                            <input type="text" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full' placeholder='Enter Phone' />
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Country</h6>
                            <select value={selectedCountry}
                                onChange={(e) => setSelectedCountry(e.target.value)}
                                name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Select Country</option>
                                {countries?.map((country, index) => (
                                    <option key={index} value={country?.iso2}>
                                        {country?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {states.length > 0 && (
                            <div className='flex flex-col gap-[10px] items-start'>
                                <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">State</h6>
                                <select
                                    value={selectedState}
                                    onChange={(e) => setSelectedState(e.target.value)}
                                    name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                    <option value="">Select State</option>
                                    {states?.map((state, index) => (
                                        <option key={index} value={state?.iso2}>
                                            {state?.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {cities.length > 0 && (
                            <div className='flex flex-col gap-[10px] items-start'>
                                <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Cities</h6>
                                <select
                                    name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                    <option value="">Select State</option>
                                    {cities.map((city) => (
                                        <option key={city.id} value={city.name}>
                                            {city.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Professional Background</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Select Professional Background</option>
                                {professionalBackgroundArray.map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Professional Industry</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Select Professional Industry</option>
                                {professionalIndustryArray.map((industry, index) => (
                                    <option key={index} value={industry}>
                                        {industry}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Industry Expertise</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Select Industry Expertise</option>
                                {industryExpertiseArray.map((expertise, index) => (
                                    <option key={index} value={expertise}>
                                        {expertise}
                                    </option>
                                ))}

                            </select>
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Undergraduate Degree</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Select Undergraduate Degree</option>
                                {undergraduateDegreeArray.map((degree, index) => (
                                    <option key={index} value={degree}>
                                        {degree}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Postgraduate Degree</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Select Postgraduate Degree</option>
                                {postgraduateDegreeArray.map((degree, index) => (
                                    <option key={index} value={degree}>
                                        {degree}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Socials</h6>
                            <input type="text" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full' placeholder='Enter Socials' />
                        </div>
                        <div className='flex flex-col gap-[10px] items-start'>
                            <h6 className="font-[500] font-manrope text-[16px] leading-[20px] text-[#000000]">Areas Of Interests</h6>
                            <select name="" id="" className='font-[400] font-manrope text-[14px] leading-[20px] text-[#838A95] py-[8px] px-[16px] rounded-[8px] bg-[#F7F7F7] border border-[#E6E6E6] w-full'>
                                <option value="">Select</option>
                            </select>
                        </div>
                    </form>
                    {/* <p className="font-[500] font-manrope text-[14px] leading-[14px] text-[#000000] text-center pt-[30px] pb-[22px]">Your data will be used only for alumni-related communication."</p> */}
                    <div className='flex justify-center pt-[20px] items-center'>
                        <button
                            className="group flex items-center justify-center lg:justify-start gap-[20px] sm:gap-[30px] bg-primary rounded-[4px] py-[12px] sm:py-[14px] px-[18px] sm:px-[20px] font-[500] font-manrope text-[14px] sm:text-[16px] leading-[24px] sm:leading-[26px] text-[#FFFFFF] transition-all duration-300 hover:text-primary border border-primary hover:bg-transparent"
                        >
                            Submit
                            <ArrowRight
                                size={18}
                                className="transition-transform duration-300 group-hover:translate-x-1"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegisterModal
